import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { PRE_ORDER_PRODUCTS } from 'config/constants';
import { isAutoApplyCouponValid, isSeptPromoValid } from 'utils/helpers';

import ParallelArrows from 'assets/images/parallel-arrows-blue.png';
import IcDamageCover from 'assets/images/general/ic-damage-cover.svg';
import IcFreeMonth from 'assets/images/general/ic-free-month.svg';
import Ic5GrabVoucher from 'assets/images/general/ic-5-grab-voucher.svg';
import IcTwentyPerrcentOff from 'assets/images/general/20-percent-off.svg';

import './Freebies.scss';

Freebies.propTypes = {
    product: PropTypes.object,
    selectedRentalPeriod: PropTypes.object,
    maxTradeInValue: PropTypes.number
};

export default function Freebies({ product, selectedRentalPeriod, maxTradeInValue }) {
    const [freebies, setFreebies] = useState([]);
    const [mobFreebies, setMobFreebies] = useState([]);
    const isPreOrderProduct = PRE_ORDER_PRODUCTS.includes(product?.slug);
    const allFreebies = [
        {
            id: 1,
            html_text: `Trade-in: Cashback up to <span class="freebies__tiles__tile__value">$${maxTradeInValue}</span>`,
            icon: ParallelArrows
        },
        {
            id: 2,
            html_text: '<span class="freebies__tiles__tile__value">FREE</span> Damage Cover',
            icon: IcDamageCover
        },
        {
            id: 3,
            html_text: '<span class="freebies__tiles__tile__value">FREE</span> + 1 Month',
            icon: IcFreeMonth
        },
        {
            id: 4,
            html_text: '<span class="freebies__tiles__tile__value">FREE $5</span> Grab Voucher',
            icon: Ic5GrabVoucher
        },
        {
            id: 5,
            html_text: '<span class="freebies__tiles__tile__value">20% OFF</span> for 12 months',
            icon: IcTwentyPerrcentOff
        },
        {
            id: 6,
            html_text: '<span class="freebies__tiles__tile__value">$100 Overtrade</span> bonus',
            icon: ParallelArrows
        }
    ];

    const allMobFreebies = [
        {
            id: 1,
            html_text: `Trade-in: Cashback up to <span class="freebies__tiles__tile__value">$${maxTradeInValue}</span>`,
            icon: ParallelArrows
        },
        {
            id: 2,
            html_text: '<span class="freebies__tiles__tile__value">FREE</span> Damage Cover',
            icon: IcDamageCover
        },
        {
            id: 3,
            html_text: '<span class="freebies__tiles__tile__value">FREE</span> + 1 Month',
            icon: IcFreeMonth
        },
        {
            id: 4,
            html_text: '<span class="freebies__tiles__tile__value">20% OFF</span> for 12 months',
            icon: IcTwentyPerrcentOff
        },
        {
            id: 5,
            html_text: '<span class="freebies__tiles__tile__value">$100 Overtrade</span> bonus',
            icon: ParallelArrows
        }
    ];

    const filtersPDPFreebies = (key = '') => {
        let filteredFreebies = [];
        let filteredMobFreebies = [];

        if (key === 'augustPromo') {
            filteredFreebies = allFreebies.filter((item) => item.id < 5);
            filteredMobFreebies = allMobFreebies.filter((item) => item?.id < 4);
        } else if (key === 'septPromo') {
            filteredFreebies = allFreebies.filter((item) => item?.id !== 3 && item?.id !== 4);
            filteredMobFreebies = allMobFreebies.filter((item) => item?.id !== 3);
        } else {
            filteredFreebies = allFreebies.filter((item) => item?.id < 3);
            filteredMobFreebies = allMobFreebies.filter((item) => item?.id < 3);
        }

        setFreebies(filteredFreebies);
        setMobFreebies(filteredMobFreebies);
    };

    useEffect(() => {
        if (isPreOrderProduct) {
            if (isAutoApplyCouponValid()) {
                filtersPDPFreebies('augustPromo');
            } else if (isSeptPromoValid() && selectedRentalPeriod?.duration_time === 12) {
                filtersPDPFreebies('septPromo');
            } else {
                filtersPDPFreebies();
            }
        } else {
            filtersPDPFreebies();
        }
    }, [selectedRentalPeriod]);

    return (
        <div className='freebies'>
            <div className='freebies__desktop'>
                <div className='freebies__tiles'>
                    {freebies.map((item) => (
                        <div className='freebies__tiles__tile' key={item.id}>
                            <img src={item.icon} alt='icon' className='freebies__tiles__tile__icon' />
                            <div>
                                <p dangerouslySetInnerHTML={{ __html: item.html_text }} className='mb-0'/>
                                <p className='freebies__tiles__tile__note'>{item.note}</p>
                            </div>
                        </div>
                    ))}
                </div>
                {(isPreOrderProduct && isAutoApplyCouponValid()) && <div className='freebies__tiles__tile freebies__tiles__tile-with-note'>
                    <img src={Ic5GrabVoucher} alt='icon' className='freebies__tiles__tile__icon' />
                    <div>
                        <p className='mb-0'><span className='freebies__tiles__tile__value'>FREE $20</span> Grab + Amazon Vouchers</p>
                        <p className='freebies__tiles__tile__note'>*Students only</p>
                    </div>
                </div>}
            </div>

            <div className='freebies__mobile'>
                <div className='freebies__tiles'>
                    {mobFreebies.map((item) => (
                        <div className='freebies__tiles__tile' key={item.id}>
                            <img src={item.icon} alt='icon' className='freebies__tiles__tile__icon' />
                            <div>
                                <p dangerouslySetInnerHTML={{ __html: item.html_text }} className='mb-0'/>
                                <p className='freebies__tiles__tile__note'>{item.note}</p>
                            </div>
                        </div>
                    ))}
                    {(isPreOrderProduct && isAutoApplyCouponValid()) && <div className='freebies__tiles__tile'>
                        <img src={Ic5GrabVoucher} alt='icon' className='freebies__tiles__tile__icon' />
                        <div>
                            <p className='mb-0'>
                                <span className='freebies__tiles__tile__value'>FREE $20</span> Grab + Amazon
                                <span className='freebies__tiles__tile__note'> (*Students only)</span>
                            </p>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    );
}
